export const BUILD_VERSION_API_PATH = '/api/build-version';

export function shouldReloadForNewDeploy(loadedSha: string, liveSha: string | null | undefined): boolean {
  return Boolean(liveSha && liveSha !== loadedSha);
}

export async function fetchLiveBuildSha(): Promise<string | null> {
  const response = await fetch(BUILD_VERSION_API_PATH, { cache: 'no-store' });
  if (!response.ok) {
    return null;
  }

  const data = (await response.json()) as { sha: string | null };
  return data.sha ?? null;
}
